import Avatar from "./avatar.png";
import Donn from "./donn.png";
import Kristin from "./kristin.png";
import Peniel from "./peniel.png";
import Rosy from "./rosy.png";
import Wrangler from "./wrangler.png";
import ChatBg from "./chat-bg.png";
import WalletBg from "./wallet-bg-pattern.png";

const assets = { Avatar, Donn, Kristin, Peniel, Rosy, Wrangler, ChatBg, WalletBg };

export default assets;
